import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SiteSelectorTableComponent } from "./site-selector-table.component";

@NgModule({
  declarations: [SiteSelectorTableComponent],
  imports: [CommonModule],
  exports: [SiteSelectorTableComponent],
})
export class SiteSelectorTableModule {}
